import { Node, mergeAttributes } from "@tiptap/core";

export const Div = Node.create({
  name: "div",
  group: "block",
  content: "block*",
  defining: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute("id"),
        renderHTML: (attributes) => (attributes.id ? { id: attributes.id } : {}),
      },
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => (attributes.class ? { class: attributes.class } : {}),
      },
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => (attributes.style ? { style: attributes.style } : {}),
      },
      /**
       * Table wrappers are divs carrying `data-for-table` / `data-table-wrapper`,
       * which the generated horizontal-scroll and alignment CSS is scoped to.
       * Without this passthrough every re-render stripped them and the wrapper
       * rules stopped matching.
       */
      dataAttributes: {
        default: null,
        parseHTML: (element) => {
          const data: Record<string, string> = {};
          Array.from(element.attributes).forEach((attr) => {
            if (attr.name.startsWith("data-")) data[attr.name] = attr.value;
          });
          return Object.keys(data).length > 0 ? data : null;
        },
        renderHTML: (attributes) => (attributes.dataAttributes as Record<string, string> | null) ?? {},
      },
    };
  },

  parseHTML() {
    return [{ tag: "div" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), 0];
  },
});


